export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_PREV = 'SET_PREV'
export const SET_NEXT = 'SET_NEXT'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_BY = 'SET_FILTER_BY'

export const SET_CHECKED = 'SET_CHECKED'

export const RESET_CHANNELS = 'RESET_CHANNELS'
export const RESET_MESSAGES = 'RESET_MESSAGES'
export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_CHANNELS = 'SET_CHANNELS'
export const SET_USER_CHANNELS = 'SET_USER_CHANNELS'
export const SET_CHANNEL = 'SET_CHANNEL'
export const SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL'
export const RESET_FOUND_MEMBERS = 'RESET_FOUND_MEMBERS'
export const SET_FOUND_MEMBERS = 'SET_FOUND_MEMBERS'
export const SET_NEW_MEMBERS = 'SET_NEW_MEMBERS'
export const SET_REPORT = 'SET_REPORT'
export const SET_CHANNEL_METADATA = 'SET_CHANNEL_METADATA'
export const SET_USERS = 'SET_USERS'
export const RESET_USERS = 'RESET_USERS'
export const SET_USER_CHANNEL_COUNT = 'SET_USER_CHANNEL_COUNT'

export const CHAT_SEARCH_TERM = 'CHAT_SEARCH_TERM'
export const CHAT_PAGE_SIZE = 'CHAT_PAGE_SIZE'
export const CHAT_PREV = 'CHAT_PREV'
export const CHAT_NEXT = 'CHAT_NEXT'
export const CHAT_SORT_DIR = 'CHAT_SORT_DIR'
export const CHAT_ORDER_BY = 'CHAT_ORDER_BY'
export const CHAT_FILTER_BY = 'CHAT_FILTER_BY'



// WEBPACK FOOTER //
// ./src/store/modules/chatadmin/types.js